module.exports = __webpack_public_path__ + "img/questionCount.5e0ba177.svg";